import { Box, Flex } from '@chakra-ui/react'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { NavBarContext } from '../../providers'
import { colors } from '../../../ui-kit'
import MainContent from './MainContent'

interface Props {
  menu?: JSX.Element | null
  children: JSX.Element | JSX.Element[]
}

const BaseLayoutWrapper = styled(Box)<{isOpen: boolean}>`
  background-color: ${colors.appPaleGrey};
  width: 100%;
  height: 100%;
  display: flex;
  max-width: ${props =>
    window.isMediaLibraryWidget || window.publicLinkInfo?.isPublicLink
      ? '100vw'
      : `calc(
    100vw - ${props.isOpen ? '260px' : '72px'}
  )`};
`

// NavBar      : 348px     = 0.18% | separated ~ null
// MenuBar     : 447px     = 0.23% | 447/1572  ~ 28%
// MainContent : remaining = 0.59% | rest      ~ 72%

const BaseLayout = ({ children, menu }: Props): React.ReactElement => {
  const { isOpen } = useContext(NavBarContext)

  if (!menu) {
    return (
      <BaseLayoutWrapper as="main" role="main" isOpen={isOpen ?? false}>
        <MainContent flex="1">
          {children}
        </MainContent>
      </BaseLayoutWrapper>
    )
  }

  return (
    <BaseLayoutWrapper as="main" role="main" isOpen={isOpen ?? false}>
      <Flex flex="0 0 330px" maxWidth="330px">
        {menu}
      </Flex>
      {/* TODO check whether adding maxWidth is correct */}
      <MainContent flex="72">
        {children}
      </MainContent>
    </BaseLayoutWrapper>
  )
}

export default BaseLayout
